
import { useLocation } from "react-router-dom";
import AccountIcon from "../../assets/icons/accountIcon";
import UserIcon from "../../assets/icons/artistIcon";
import DiscoverIcon from "../../assets/icons/discoverIcon";
import TxoriaLogo from "../../assets/icons/logo";
import PaperIcon from "../../assets/icons/paperIcon";
import { useAppContext } from "../../context/appContext";
import { getApiUrl } from "../../data/api/apiManager";
import "./header.css";
import HeaderLink from "./headerLink";

export default function Header() {

    const location = useLocation();
    
    const {userData, isLoggedIn} = useAppContext();

    return <header className="keep-margin">
        <h2 onClick={() => {
            window.open("/pieces", "_self");
        }} className="pointer center-icons"><TxoriaLogo/>Txoria</h2>
        <ul>
            <HeaderLink icon={<DiscoverIcon />} name="Discover" link="discover" />
            <HeaderLink icon={<PaperIcon />} name="Pieces" link="pieces" />
            <HeaderLink icon={<UserIcon />} name="Artists" link="artists" />
            <HeaderLink icon={isLoggedIn ? <img src={getApiUrl("assets/by-hash/" + userData?.artist?.profilePicture)} className="profile-picture"/> : <AccountIcon />} name={userData ? "Profile" : "Login"} link={userData ? "dashboard" : "login"} />
        </ul>
    </header>;
}